import { useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import { calcluateFees } from 'lib/firebase/utils';
import { set, keys } from 'lib/utils/localStorage';
import Summary from './summary';
import Tabs from './tabs';

import styles from './salonAccount.module.scss';

const SalonAccount = ({ customer, locale, salons, global }) => {
  const [selectedSalon, setSelectedSalon] = useState(salons[0]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showInfoBoxReturn, setShowInfoBoxReturn] = useState(false);

  const router = useRouter();

  const isMultiSalon = salons.length > 1;

  const canRequestPayout = Boolean(
    salons.filter(s =>
      s?.parentEmail !== '' ? s?.parentEmail === customer.email : s?.salonEmail === customer.email
    )
  );

  const { total, payable, paid, awaitingReturnsPeriod } = calcluateFees(
    selectedSalon.orders,
    selectedSalon.salonKickbackfeeMargin
  );

  const handleDropdown = () => (isMultiSalon ? setDropdownOpen(!dropdownOpen) : null);

  const handlePickSalon = salon => {
    setSelectedSalon(salon);
    set(keys.LOGGED_SALON_NO, salon.salonNo);
    setDropdownOpen(!dropdownOpen);
  };

  const handleRefresh = () => router.reload();

  const filteredSalon = useMemo(
    () => ({
      ...selectedSalon,
      orders: selectedSalon.orders.filter(order => order.status !== 'expired'),
    }),
    [selectedSalon]
  );

  const summaryPayload = {
    customer,
    salon: filteredSalon,
    salons,
    isMultiSalon,
    dropdownOpen,
    handleDropdown,
    handlePickSalon,
    handleRefresh,
    canRequestPayout,
    showInfoBoxReturn,
    setShowInfoBoxReturn,
    fees: { total, payable, paid, awaitingReturnsPeriod },
  };

  return (
    <div className={styles.salonAccountPage}>
      <div className={styles.container}>
        <Summary locale={locale} payload={summaryPayload} global={global} />
        <Tabs salon={filteredSalon} global={global} locale={locale} />
      </div>
    </div>
  );
};

export default SalonAccount;
